<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8.00008" cy="8.00002" r="1.33333" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.6666 7.99998C12.8886 11.1113 10.6666 12.6666 7.99992 12.6666C5.33325 12.6666 3.11125 11.1113 1.33325 7.99998C3.11125 4.88865 5.33325 3.33331 7.99992 3.33331C10.6666 3.33331 12.8886 4.88865 14.6666 7.99998" stroke="black" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
  